import { fetchWrapper } from "_helpers";

const baseUrl = `${process.env.REACT_APP_API_URL}${process.env.REACT_APP_API_CONTEXT_PATH}/companies`;

export const companyService = {
  getAll,
  getSuggestion,
  getSuggestionMap,
  search,
  getById,
  create,
  update,
  delete: _delete,
  getSupplierAddress,
};

function getAll() {
  return fetchWrapper.get(baseUrl);
}

function search(params) {
  return fetchWrapper.get(`${baseUrl}${params}`);
}

function getSuggestion(params) {
  return fetchWrapper.get(`${baseUrl}/suggestion${params}`);
}

function getSuggestionMap(params) {
  return fetchWrapper.get(`${baseUrl}/map/suggestion`);
}

function getById(id) {
  return fetchWrapper.get(`${baseUrl}/${id}`);
}

function create(params) {
  return fetchWrapper.post(baseUrl, params);
}

function update(id, params) {
  return fetchWrapper.put(`${baseUrl}/${id}`, params);
}

function _delete(id) {
  return fetchWrapper.delete(`${baseUrl}/${id}`);
}

function getSupplierAddress(supplierId) {
  return fetchWrapper.get(`${baseUrl}/${supplierId}/addresses`);
}
